import React, { useEffect, useRef, useState } from 'react'
import { Card, Modal } from 'antd'
import dayjs from 'dayjs'
import {
  dateFormatYearMonthDay,
  dateFormatYearMonthDayTime,
  downLoadFileBlob,
  formatEndTime,
  formatMessageNew,
  formatStartTime,
  initDateFormat,
  initValueAndLabel,
  paginationInit,
  uniqueFun,
  parseToArray
} from '@/utils/common'
import { exportObClaimReport, getObClaimReportQuery } from '@/services/rfid/reports/obClaimReport'
import { getOutboundScanDropList } from '@/services/rfid/reports/obClaimReport'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import ObClaimEpcModalTable from '@/pages/rfid/reports/components/ObClaimEpcModalTable'
import { CARTON_PE } from '@/utils/types'
import { modalError } from '@/utils/modalUtils'

const MAX_LIST_SIZE = 50

const ObClaimReport = () => {
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectItem, setSelectItem] = useState({})
  const mounting = useRef(false)
  let formRef = useRef(null)

  const searchListInit = [
    {
      type: 'select',
      label: 'languageObj.obClaimReport.plant',
      key: 'plant',
      allowClear: true,
      initialValues: null,
      selectList: [],
      spans: { xl: 8, xxl: 8 },
      isdefaultfilter: 'true'
    },
    {
      type: 'textarea',
      label: 'languageObj.obClaimReport.major',
      key: 'major',
      initialValues: '',
      spans: { xl: 8, xxl: 8 },
      isdefaultfilter: 'true'
    },
    {
      type: 'textarea',
      label: 'languageObj.obClaimReport.majorSerialNo',
      key: 'majorSerialNo',
      initialValues: '',
      spans: { xl: 8, xxl: 8 },
      isdefaultfilter: 'true'
    },
    {
      type: 'textarea',
      label: 'languageObj.obClaimReport.dn',
      key: 'dn',
      initialValues: '',
      spans: { xl: 8, xxl: 8 },
      isdefaultfilter: 'true'
    },
    {
      type: 'textarea',
      label: 'languageObj.obClaimReport.cartonNo',
      key: 'cartonNo',
      initialValues: '',
      spans: { xl: 8, xxl: 8 },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.obClaimReport.giDate',
      key: 'giDate',
      format: dateFormatYearMonthDay,
      initialValues: [],
      allowClear: true,
      disabledDate: (current, { from } = {}) => {
        if (!current) return false
        const c = dayjs(current).startOf('day')
        const todayEnd = dayjs().endOf('day')
        if (c.isAfter(todayEnd)) return true
        if (from) {
          const anchor = dayjs(from).startOf('day')
          const minAllowed = anchor.subtract(6, 'day').startOf('day')
          const maxAllowed = anchor.add(6, 'day').endOf('day')
          if (c.isBefore(anchor)) {
            return c.isBefore(minAllowed) || c.isAfter(anchor)
          }
          return c.isBefore(anchor) || c.isAfter(maxAllowed)
        }
        return false
      },
      spans: { xl: 8, xxl: 8 },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.obClaimReport.pe',
      key: 'peList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: CARTON_PE,
      spans: { xl: 8, xxl: 8 }
    },
    {
      type: 'input',
      label: 'languageObj.obClaimReport.productCode',
      key: 'productCode',
      initialValues: '',
      spans: { xl: 8, xxl: 8 }
    },
    {
      type: 'input',
      label: 'languageObj.obClaimReport.sku',
      key: 'sku',
      initialValues: '',
      spans: { xl: 8, xxl: 8 }
    }
  ]

  const [searchList, setSearchList] = useState(searchListInit)

  const tableColumns = [
    {
      title: () => formatMessageNew('languageObj.obClaimReport.plant'),
      dataIndex: 'plant',
      width: 80,
      fixed: 'left',
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.dc'),
      dataIndex: 'dc',
      width: 80,
      fixed: 'left',
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.major'),
      dataIndex: 'major',
      width: 140,
      fixed: 'left',
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.cartonNo'),
      dataIndex: 'cartonNo',
      width: 140,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.productCode'),
      dataIndex: 'productCode',
      width: 120,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.size'),
      dataIndex: 'size',
      width: 80,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.giQty'),
      dataIndex: 'giQty',
      width: 100,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.scannedEpcQty'),
      dataIndex: 'scannedEpcQty',
      width: 120,
      render: (text, record) => {
        if (text) {
          return (
            <div
              className="link_name word_break_all"
              onClick={() => {
                setSelectItem(record)
                setModalVisible(true)
              }}
            >
              {text}
            </div>
          )
        }
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.dn'),
      dataIndex: 'dn',
      width: 140,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.serialNoOfCtn'),
      dataIndex: 'serialNoOfCtn',
      width: 120,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.client'),
      dataIndex: 'client',
      width: 160,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.city'),
      dataIndex: 'city',
      width: 120,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.carrierVendorCode'),
      dataIndex: 'carrierVendorCode',
      width: 140,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.giDate'),
      dataIndex: 'giDate',
      width: 160,
      render: text => <div className="word_break_all">{initDateFormat(text, dateFormatYearMonthDayTime)}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.lastScannedDate'),
      dataIndex: 'lastScannedDate',
      width: 160,
      render: text => <div className="word_break_all">{initDateFormat(text, dateFormatYearMonthDayTime)}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.actualWeight'),
      dataIndex: 'actualWeight',
      width: 120,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: () => formatMessageNew('languageObj.obClaimReport.pe'),
      dataIndex: 'pe',
      width: 80,
      render: text => <div className="word_break_all">{text}</div>
    }
  ]

  useEffect(() => {
    searchSelectDropFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const searchSelectDropFun = () => {
    getOutboundScanDropList().then(res => {
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'plant') {
          const rawPlantDrop = res.resultData || []
          const resPlantDt = rawPlantDrop
          const uniqueDt = initValueAndLabel(uniqueFun(resPlantDt, 2))
          itemFirst.selectList = uniqueDt
        }
      })
      setSearchList([...searchListInit])
    })
  }

  const validateListSize = (list, labelKey) => {
    if (list.length > MAX_LIST_SIZE) {
      return {
        ok: false,
        message: `${formatMessageNew(`languageObj.obClaimReport.${labelKey}`)}: ${formatMessageNew(
          'languageObj.obClaimReport.maxInputError'
        )}`
      }
    }
    return { ok: true }
  }

  const validateSearchParams = info => {
    const majorList = parseToArray(info.major)
    const dnList = parseToArray(info.dn)
    const cartonList = parseToArray(info.cartonNo)
    const majorSerialList = parseToArray(info.majorSerialNo)
    const gi = info.giDate
    const hasGi = gi && gi.length > 0

    const checks = [
      validateListSize(majorList, 'major'),
      validateListSize(dnList, 'dn'),
      validateListSize(cartonList, 'cartonNo'),
      validateListSize(majorSerialList, 'majorSerialNo')
    ]
    for (const c of checks) {
      if (!c.ok) return c
    }

    const hasMajor = majorList.length > 0
    const hasMajorSerial = majorSerialList.length > 0
    const hasDn = dnList.length > 0
    const hasCarton = cartonList.length > 0
    if (!hasMajor && !hasMajorSerial && !hasDn && !hasCarton && !hasGi) {
      return { ok: false, message: formatMessageNew('languageObj.obClaimReport.searchOptionError') }
    }
    const onlyGiDate = hasGi && !hasMajor && !hasMajorSerial && !hasDn && !hasCarton
    if (onlyGiDate && gi[0] && gi[1]) {
      const start = dayjs(gi[0]).startOf('day')
      const end = dayjs(gi[1]).startOf('day')
      if (end.diff(start, 'day') > 6) {
        return { ok: false, message: formatMessageNew('languageObj.obClaimReport.giDateOnlyRangeError') }
      }
    }
    return { ok: true }
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const majorList = parseToArray(info.major)
    const dnList = parseToArray(info.dn)
    const cartonList = parseToArray(info.cartonNo)
    const majorSerialList = parseToArray(info.majorSerialNo)
    const { giDate } = info
    const hasGi = giDate && giDate.length > 0
    const hasOtherCriteria = majorList.length > 0 || dnList.length > 0 || cartonList.length > 0
    const applyGiDate = hasGi && !hasOtherCriteria
    const params = {
      ...info,
      giDateStart: applyGiDate ? formatStartTime(giDate) : null,
      giDateEnd: applyGiDate ? formatEndTime(giDate) : null,
      majorList,
      majorSerialNoList: majorSerialList,
      dnList,
      cartonNoList: cartonList
    }
    delete params.major
    delete params.dn
    delete params.cartonNo
    delete params.majorSerialNo
    delete params.giDate
    return params
  }

  const searchDataBtn = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const valid = validateSearchParams(info)
    if (!valid.ok) {
      modalError({ content: valid.message })
      return
    }
    mounting.current = true
    setPagination(prev => ({ ...prev, currentPage: 1 }))
    setQueryFlag(flag => !flag)
  }

  const searchClearDataBtn = () => {
    mounting.current = false
    formRef && formRef.current && formRef.current.clearForm()
    setTableList([])
    setPagination({ ...paginationInit })
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(flag => !flag)
  }

  const searchDataFun = () => {
    const params = {
      ...getParams(),
      pageSize: pagination.pageSize,
      page: pagination.currentPage
    }
    getObClaimReportQuery(params).then(res => {
      const dt = (res && res.resultData) || {}
      setTableList(dt.records || [])
      setPagination(prev => ({
        ...prev,
        total: dt.total || 0
      }))
    })
  }

  const downLoadFun = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const valid = validateSearchParams(info)
    if (!valid.ok) {
      modalError({ content: valid.message })
      return
    }
    exportObClaimReport({
      ...getParams()
    }).then(res => downLoadFileBlob(res))
  }

  const handleModalCancel = () => {
    setModalVisible(false)
    setSelectItem({})
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showSearchBtn={true}
            showClearBtn={true}
            showCollapseBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container overflow_visible auto-mt20">
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={tableList}
            columns={tableColumns}
            columnsKey="columns_obClaimReport"
            onDownload={downLoadFun}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
      <Modal
        open={modalVisible}
        destroyOnClose={true}
        className="nike_modal"
        width="85%"
        title={formatMessageNew('languageObj.obClaimReport.epcDetail')}
        onCancel={handleModalCancel}
        footer={null}
      >
        <ObClaimEpcModalTable selectItem={selectItem} />
      </Modal>
    </div>
  )
}

export default ObClaimReport
